import API, {isMd} from '../api';

export const getStepPage_3 = (params) => {
  let paramsString = new URLSearchParams(params);

  return API.get(`/api/v1/step/three?${paramsString}`);
};

export const searchCityRequest = (params) => {
  return API.post(`/api/v1/step/three/search-city`, params);
};
export const searchDealerRequest = (params) => {
  return API.post(`/api/v1/step/three/search`, params);
};

export const sendCarParams = (params, data) => {
  let paramsString = new URLSearchParams(params);

  return API.post(`/api/v1/step/one?${paramsString}`, data);
};

export const getCityMapBox = (query, mapboxToken, lang) => {
    const country = isMd ? 'md' : 'ua'
    return API.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${mapboxToken}&country=${country}&language=${lang.code}&types=place,locality,neighborhood,region,postcode`,
    );
};
